// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1tV-I","content":"styles_content__20PNI","checkbox":"styles_checkbox__3D5pN","checkboxLabel":"styles_checkboxLabel__u8Xg5"};